<template>
  <v-main>
    <v-container fluid>
      <OSimpleDialog
        :maxWidth="800"
        ref="helpDialog"
        title="Formato dos Dados"
        :showButtons="false"
      >
        <v-card-text class="pa-6 d-flex items-start">
          <pre>{{ helpText }}</pre>
        </v-card-text>
      </OSimpleDialog>

      <OSimpleDialog
        :maxWidth="800"
        ref="importDialog"
        title="Importar"
        @apply="doParse"
      >
        <v-card-text class="pa-6 d-flex items-start">
          <v-textarea
            :rows="15"
            class="textarea-mono"
            v-model="strInput"
            filled
            hide-details
          />
        </v-card-text>
      </OSimpleDialog>

      <div class="d-flex gap-6">
        <!-- h-600 -->
        <div class="w-1/3 h-600 d-flex flex-column">
          <!-- h-100% -->
          <v-card
            class="d-flex flex-column flex-grow-1 flex-shrink-1 max-h-full"
          >
            <!-- fixed bar -->
            <div
              class="card-bar d-flex items-center pa-2 flex-grow-0 flex-shrink-0"
            >
              <div class="pl-2 text-h6 font-weight-regular">Pontos</div>
              <v-spacer />
              <v-switch
                v-model="showLabel"
                label="Destacar label"
                single-line
                hide-details
                class="mt-0"
              />
              <v-spacer />
              <v-btn @click="() => $refs.importDialog.open()">
                Carregar...
              </v-btn>
            </div>

            <!-- scrollable content -->
            <div class="flex-grow-1 flex-shrink-1 overflow-y-auto">
              <v-simple-table>
                <template v-slot:default>
                  <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                    <col width="120" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Lat</th>
                      <th>Lng</th>
                      <th>Extra0</th>
                      <th>Extra1</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(p) in points"
                      :key="p.id"
                      @mouseover="highlight(p)"
                      :class="{'row-highlight': highlightedPoint != null && highlightedPoint.id == p.id}"
                    >
                      <td>{{ p.lat }}</td>
                      <td>{{ p.lng }}</td>
                      <td>{{ p.extra0 }}</td>
                      <td>{{ p.extra1 }}</td>
                      <td class="text-right">
                        <!-- Concluí que é mais intuitivo cortar entre este ponto e o próximo, ao invés de entre este e o anterior. -->
                        <!-- <div class="hover-button">
                          <v-btn
                            icon
                            title="Cortar entre este e o anterior"
                            :disabled="jdx == path.points.length - 1"
                            @click="cutPath(idx, jdx + 1)"
                          >
                            <v-icon small>mdi-scissors-cutting</v-icon>
                          </v-btn>
                        </div> -->
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card>
        </div>

        <div class="w-2/3 h-600 overflow-y-scroll">
          <pre v-if="err != null">{{ err }}</pre>

          <div style="position: relative; height: 600px; width: 100%">
            <OMap2
              ref="theMap"
              :height="600"
              :markers="markers"
              :maxZoom="23"
              :polygons="polygons"
              @markerClicked="markerClicked"
            />
          </div>
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'
import OMap2 from 'oderon-vue/maps/OMap2.vue'
import { getBounds } from 'map-utils'

const helpText = `# Comentários
# Colunas podem ser separadas por espaços,
# tab, vírgula ou ponto-e-vírgula
# lat       lng         timestamp
-17.962353	-46.830027	2025-12-24 00:01:32
-17.962336	-46.830044	2025-12-24 00:06:54
-17.962321	-46.830049	2025-12-24 00:10:27

# Linhas em branco criam outros paths
-17.962321	-46.830047	2025-12-24 00:10:49
-17.962321	-46.830047	2025-12-24 00:11:11
-17.962325	-46.830056	2025-12-24 00:16:32
`

const polygons = [
 {
  "id": 146,
  "name": "Superfície Vazante",
  "description": null,
  "points": [
   [
    -17.97240342014846,
    -46.88052630010022
   ],
   [
    -17.994363913971203,
    -46.86533426823987
   ],
   [
    -17.975669093997045,
    -46.793579812673464
   ],
   [
    -17.895479367160554,
    -46.79323648991956
   ],
   [
    -17.895969434987844,
    -46.82516550603284
   ],
   [
    -17.902340193557894,
    -46.827482934621706
   ],
   [
    -17.91091585335657,
    -46.83417772832288
   ],
   [
    -17.938845125510557,
    -46.836495156911745
   ],
   [
    -17.948725479591285,
    -46.84464907231702
   ],
   [
    -17.956662111961084,
    -46.85571429937413
   ],
   [
    -17.96421456396514,
    -46.872022130184675
   ],
   [
    -17.971480942839026,
    -46.88167808263829
   ]
  ],
  "tolerancePoints": null,
  "extraInfo": {
   "bbox": [
    [
     -17.994363913971203,
     -46.88167808263829
    ],
    [
     -17.895479367160554,
     -46.79323648991956
    ]
   ],
   "center": [
    -17.94492164056588,
    -46.83745728627892
   ]
  },
  "appliesTo": {
   "whitelist": [
    {
     "type": "all"
    }
   ]
  },
  "layer": 1,
  "value": 50,
  "createdAt": "2021-03-12T17:58:18.000Z",
  "updatedAt": "2021-04-29T18:21:16.000Z",
  "tags": [
   "ProjetoGeral",
   "Embarcavel"
  ],
  "layerLabel": "Camada 1",
  "valueLabel": "Limite 50km/h"
 }
]

export default {
  components: {
    OMap2,
    OSimpleDialog
  },
  data() {
    return {
      helpText,
      now: new Date(),
      strInput: helpText,
      err: null,
      points: [],
      highlightedPoint: null,
      showLabel: false,
      polygons
    }
  },
  watch: {
    points: {
      handler() {
        let bounds = getBounds(this.points)
        setTimeout(() => this.$refs.theMap.fitBounds(bounds), 500)
      },
      immediate: true
    }
  },
  computed: {
    markers() {
      let result = []

      for (let point of this.points) {
        let label = null
        if (this.showLabel) {
          label = [nullIfEmpty(point.extra0), nullIfEmpty(point.extra1)]
          label = label
            .filter((x) => x != null)
            .join('\n')
            .trim()

          label = nullIfEmpty(label)
        }

        let marker = {
          id: point.id,
          lat: point.lat,
          lng: point.lng,
          cssClass: 'solid-marker',
          label
        }

        if ( this.highlightedPoint && this.highlightedPoint.id == point.id )
          marker.cssClass = 'solid-marker highlighted'

        marker.cssClass += ' marker-' + point.extra0

        result.push(marker)
      }

      return result
    }
  },
  methods: {
    highlight(point /*, index*/) {
      this.highlightedPoint = point
    },
    doParse() {
      this.$refs.importDialog.dismiss()
      try {
        this.err = null
        this.points = parse(this.strInput)
      } catch (err) {
        this.err = err
        this.points = []
      }
    },

    markerClicked(evt) {
      // console.log(evt)
      this.highlightedPoint = this.points.find(x => x.id == evt.rowId)
    }
  }
}

function nullIfEmpty(x) {
  if (x == null) return null
  x = x.toString().trim()
  if (x.length > 0) return x
  return null
}

let _sequence = 0

function parse(strInput) {
  let result = []

  let lines = (strInput || '')
    .trim()
    .split('\n')
    .map((x) => x.trim())
  for (let line of lines) {
    if (line[0] == '#' || line.length < 1) {
      continue
    }

    let id = ++_sequence
    let parts = line.split(/[ ;,\t]+/g)
    let lat = parseFloat(parts[0])
    let lng = parseFloat(parts[1])
    if (isValidCoord(lat, lng)) {
      result.push({ id, lat, lng, extra0: parts[2], extra1: parts[3] })
    }
  }

  return result
}

function isValidCoord(lat, lng) {
  // já descarta null, undefined, Infinity, NaN, etc
  if (betweenAndNotZero(lat, -90, 90) && betweenAndNotZero(lng, -180, 180)) {
    return true
  } else {
    return false
  }
}

function betweenAndNotZero(x, min, max) {
  // isFinite testa se não é: NaN, null, undefined, 0/0, etc
  if (!Number.isFinite(x)) return false
  if (x == 0) return false
  if (x < min) return false
  if (x > max) return false
  return true
}
</script>

<style lang="sass">
.textarea-mono
  font-family: 'Courier New', Courier, monospace
  font-size: 10pt
  white-space: pre

.textarea-border
  border: 1px solid #ccc
  border-radius: 8px

/* Hide the button initially */
.hover-button
  display: none

tr:hover .hover-button
  display: flex
  justify-content: flex-end

.solid-marker
  border-style: solid !important
  border-width: 2px !important
  border-color: black !important
  background-color: #00ff00 !important

  &.highlighted
    border-width: 5px !important

  &.marker-red
    background-color: #ff0000 !important

  &.marker-blue
    background-color: #0000ff !important

  &.marker-green
    background-color: #00ff00 !important

tr.row-highlight
  background-color: #ccc
</style>
